document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.cross-page-promos');
    if (!container) return;

    const slider = container.querySelector('.usp-wrapper');
    const slides = slider?.children;
    if (!slides || slides.length <= 1) return;

    let currentIndex = 0;
    let isMobileMode = false;
    let autoplayInterval = null;

    const autoplay = window.uspSliderConfig?.autoplay || false;
    const speed = window.uspSliderConfig?.speed || 3000;

    function showSlide(index) {
        [...slides].forEach((slide, i) =>
            slide.classList.toggle('active', i === index)
        );
    }

    function showAllSlides() {
        [...slides].forEach((slide) => slide.classList.add('active'));
    }

    function setupSlider() {
        showSlide(currentIndex);
        isMobileMode = true;
        if (autoplay) startAutoplay();
    }

    function destroySlider() {
        showAllSlides();
        isMobileMode = false;
        stopAutoplay();
    }

    function checkMode() {
        const nowMobile = window.matchMedia('(max-width: 768px)').matches;
        if (nowMobile && !isMobileMode) {
            setupSlider();
        } else if (!nowMobile && isMobileMode) {
            destroySlider();
        }
    }

    function startAutoplay() {
        stopAutoplay(); // clear if already running
        autoplayInterval = setInterval(() => {
            if (!isMobileMode) return;
            currentIndex = (currentIndex + 1) % slides.length;
            showSlide(currentIndex);
        }, speed);
    }

    function stopAutoplay() {
        if (autoplayInterval) {
            clearInterval(autoplayInterval);
            autoplayInterval = null;
        }
    }

    // Initialize slider mode
    checkMode();

    const nav = container.querySelector('.slideshow-nav');
    if (!nav) return;

    const prevBtn = nav.querySelector('button[name="prev"]');
    const nextBtn = nav.querySelector('button[name="next"]');

    prevBtn?.addEventListener('click', () => {
        if (!isMobileMode) return;
        currentIndex = (currentIndex === 0) ? slides.length - 1 : currentIndex - 1;
        showSlide(currentIndex);
    });

    nextBtn?.addEventListener('click', () => {
        if (!isMobileMode) return;
        currentIndex = (currentIndex + 1) % slides.length;
        showSlide(currentIndex);
    });

    window.addEventListener('resize', checkMode);
});
